export const FORBIDDEN_STATUS: number = 403;
export const MENU_DASHBOARD: string = 'Dashboard';
export const MENU_COMPRADEUDA: string = 'Compra Deuda';
export const MENU_ADMIN: string = 'Administración';
export const ROLE_DASHBOARD: string = 'visorDashboard';
export const ROLE_ADMIN: string = 'adminDashboard';
export const VIEW_COMPRADEUDA: string = 'view_compra_deuda';
export const VIEW_FUVEX: string = 'view_fuvex';
export const ABILITIES: string[] = [VIEW_COMPRADEUDA, VIEW_FUVEX];
export const STATE_RECHAZADO_RRHH: string = 'RECHAZADO - RRHH';
